<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form ref="form">
        <v-row>
          <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-row>
            <v-col cols="6" sm="6" class="pb-n5">
              <v-text-field
                outlined
                label="Corporate ID"
                type="text"
                v-model="formData.corpid"
                maxlength="30"
                :rules="[rules.required]"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" class="pb-n5 mt-n8">
              <v-text-field
                outlined
                :label="this.$t('statutoryexportcommonused.contactpersonname')"
                type="text"
                v-model="formData.conpsnname"
                maxlength="40"
                :rules="[rules.required]"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" class="pb-n5 mt-n8">
              <v-text-field
                outlined
                :label="this.$t('statutoryexportcommonused.contactphonenumber')"
                type="number"
                v-model="formData.conpsnno"
                maxlength="20"
                :rules="[rules.required]"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" sm="3" class="pb-n5 mt-n8">
              <v-autocomplete
                outlined
                :label="this.$t('statutoryexportcommonused.statecode')"
                type="text"
                v-model="formData.statecode"
                :items="statecodeList"
                :rules="[rules.required]"
                dense
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" sm="3" class="pb-n5 mt-n8">
              <v-autocomplete
                outlined
                label="Payment Option"
                type="text"
                v-model="formData.paymentoption"
                :items="paymentoptionList"
                :rules="[rules.required]"
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="backHandler">
              {{$t('button.back')}}
            </v-btn>
          </div>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="getMaybankExportListHandler">
              {{$t('button.export')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    Loading,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },

      id: this.parentObject.id,
      data: this.parentObject.data,
      formData: {
        employername: '',
        debitacc: '',
        corpid: '',
        conpsnname: '',
        conpsnno: '',
        statecode: '',
        paymentoption: 'A',
      },

      statecodeList: [
        { text: 'Johor', value: '01' },
        { text: 'Kedah', value: '02' },
        { text: 'Kelantan', value: '03' },
        { text: 'Melaka', value: '04' },
        { text: 'Negeri Sembilan', value: '05' },
        { text: 'Pahang', value: '06' },
        { text: 'Pulau Pinang', value: '07' },
        { text: 'Perak', value: '08' },
        { text: 'Perlis', value: '09' },
        { text: 'Selangor', value: '10' },
        { text: 'Terengganu', value: '11' },
        { text: 'Sabah', value: '12' },
        { text: 'Sarawak', value: '13' },
        { text: 'Wilayah Persekutuan (Kuala Lumpur)', value: '14' },
        { text: 'Wilayah Persekutuan (Labuan)', value: '15' },
        { text: 'Wilayah Persekutuan (Putrajaya)', value: '16' },
      ],

      paymentoptionList: [
        { text: 'A - Normal Payment', value: 'A' },
        { text: 'L - Late Charges', value: 'L' },
        { text: 'D - Dividend Loss', value: 'D' },
      ],

      titleData: null,

      totalAmtEmployer: null,
      totalAmtMember: null,

      loading: false,

      accErr: [],
      epfdata: [],

      processedCount: null,
      successCount: null,
      errCount: null,
      errMsg: "",
      isErr: false,
      isEdit: this.parentObject.isEdit,
    };
  },

  methods: {
    getMaybankExportListHandler() {
      if (!this.$refs.form.validate()) {
        this.isErr = true;
        this.errMsg = this.$t('vdatatable.someinfoismissing');
        return;
      }

      this.loading = true;
      const vm = this;

      let dateHolder2 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder2).format("YYYY-MM-DD");

      this.$store.dispatch('get', {
        url: `/ambankepfexport/all/${this.$store.getters.userId}`
          + "/" + this.data.epfexprecid
          + "/" + this.data.refnum + "/" + date + "/" + date
      })
        .then(function (res) {
          vm.loading = false;
          vm.epfdata = res.data.rec;

          if (vm.epfdata.length > 0) {
            vm.formData.employername = vm.epfdata[0].compnyname || '';
            vm.formData.debitacc = vm.epfdata[0].debitaccountno || '';
          }

          if (!vm.formData.employername || !vm.formData.debitacc) {
            vm.isErr = true;
            vm.errMsg = 'No Company Bank Account is set up for this company (matched by company name in Company Bank Account Setup). Please configure one first.';
            return;
          }

          vm.exportHandler();
        })
        .catch(function (err) {
          vm.loading = false;
          vm.errMsg = err;
        });
    },

    buildHeader() {
      const batchid = "M" + moment().format("DDHHmmss");
      const refnum = String(this.data.refnum || "").replace(/[^0-9A-Za-z]/g, "").substring(0, 9);
      const monthYear = this.padRJ(this.data.month, 2) + this.data.year;
      const valuedate = moment().format("DDMMYYYY");

      const fields = new Array(42).fill("");
      fields[0] = "00";
      fields[1] = "Statutory Body";
      fields[2] = "5";
      fields[3] = "02";
      fields[4] = refnum;
      fields[5] = this.formData.employername;
      fields[6] = monthYear;
      fields[7] = this.formData.debitacc;
      fields[8] = valuedate;
      fields[10] = this.formData.paymentoption;
      fields[11] = this.formData.statecode;
      fields[16] = this.formData.conpsnname;
      fields[17] = this.formData.conpsnno;
      fields[20] = batchid;
      fields[21] = this.formData.corpid;
      return fields.join("|");
    },

    buildRecord(element) {
      const fields = new Array(136).fill("");
      const stfamountholder = (element.stfamount || 0).toFixed(2);
      const coamountholder = (element.coamount || 0).toFixed(2);
      const stfepfwageholder = (element.stfepfwage || 0).toFixed(2);
      const refno = element.refno ? String(element.refno).replace(/[-\s]/g, "") : "";

      // New ID No / Passport No: use the employee's IC if they have one on
      // file, otherwise fall back to their passport number. Old ID No is
      // left blank (not needed once New ID No or Passport No is present).
      let newicno = "";
      let passportno = "";
      if (element.personidnotype == 1 && element.personidno) {
        newicno = String(element.personidno).replace(/[-\s]/g, "");
      } else if (element.personidnotype == 3 && element.personidno) {
        passportno = element.personidno;
      }

      fields[0] = "01";
      fields[1] = element.staffcode || "";
      fields[4] = element.psnname || "";
      fields[5] = "Y";
      fields[8] = newicno;
      fields[10] = passportno;
      fields[7] = refno;
      fields[11] = stfamountholder;
      fields[12] = coamountholder;
      fields[14] = element.staffcode || "";
      fields[15] = stfepfwageholder;
      fields[16] = element.staffcode || "";
      return { text: fields.join("|"), stfamount: element.stfamount || 0, coamount: element.coamount || 0 };
    },

    buildFooter(records) {
      let totalEmployee = 0;
      let totalEmployer = 0;
      let recEmployee = 0;
      let recEmployer = 0;

      records.forEach((r) => {
        totalEmployee += r.stfamount;
        totalEmployer += r.coamount;
        if (r.stfamount != 0) recEmployee++;
        if (r.coamount != 0) recEmployer++;
      });

      this.totalAmtMember = totalEmployee.toFixed(2);
      this.totalAmtEmployer = totalEmployer.toFixed(2);

      const fields = new Array(28).fill("");
      fields[0] = "99";
      fields[1] = totalEmployee.toFixed(2);
      fields[2] = totalEmployer.toFixed(2);
      fields[3] = String(recEmployee);
      fields[4] = String(recEmployer);
      fields[5] = String(records.length);
      fields[6] = (totalEmployee + totalEmployer).toFixed(2);
      return fields.join("|");
    },

    async getData() {
      const vm = this;
      let newepfdetail = [];
      let dataholder = vm.epfdata;
      let epfdetail = this.filter(dataholder);

      this.processedCount = dataholder.length;
      this.successCount = epfdetail.length;
      this.errCount = dataholder.length - epfdetail.length;

      epfdetail.forEach(function (o) {
        var existing = newepfdetail.filter(function (i) {
          return i.staffid === o.staffid;
        })[0];
        if (!existing) {
          newepfdetail.push(o);
        } else {
          existing.coamount += o.coamount;
          existing.stfamount += o.stfamount;
          existing.stfepfwage += o.stfepfwage;
        }
      });

      const records = newepfdetail.map((element) => this.buildRecord(element));
      this.titleData = this.padRJ(vm.data.month, 2) + "_" + vm.data.year + "_MAYBANK_EPF";

      if (records.length > 0) {
        const header = this.buildHeader();
        const footer = this.buildFooter(records);
        const lines = [header, ...records.map((r) => r.text), footer];
        this.download(lines.join("\n"), this.titleData);
      }
    },

    filter(item) {
      let checkdet = this.detailfilter(item);
      let checkactive = this.activefilter(checkdet);
      let checkpayment = this.paymentfilter(checkactive);
      return checkpayment;
    },

    detailfilter(item) {
      let dateHolder = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-"
        + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder).format("YYYY-MM-DD");
      let dataitem = item.filter((e) => e.refnum == this.data.refnum);
      dataitem = dataitem.filter((e) => {
        return moment(e.startdate).format("YYYY-MM-DD") <= date && date <= moment(e.enddate).format("YYYY-MM-DD");
      });
      let noacc = item.filter((e) => !dataitem.includes(e));
      for (let i = 0; i < noacc.length; i++) {
        noacc[i].errormsg = this.$t('setupreport_exportmapping.nodetailinpersonstat');
        this.accErr.push(noacc[i]);
      }
      return dataitem;
    },

    activefilter(item) {
      let data = item.filter((e) => e.pystatcode == 'ACTIVE');
      let notactive = item.filter((e) => !data.includes(e));
      for (let i = 0; i < notactive.length; i++) {
        notactive[i].errormsg = this.$t('setupreport_exportmapping.paymentisnotactive');
        this.accErr.push(notactive[i]);
      }
      return data;
    },

    paymentfilter(item) {
      let data = item.filter((e) => {
        return e.coamount != 0 || e.stfamount != 0;
      });
      let nopayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < nopayment.length; i++) {
        nopayment[i].errormsg = this.$t('setupreport_exportmapping.nopayment');
        this.accErr.push(nopayment[i]);
      }
      return data;
    },

    download(data, title) {
      const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", title + ".txt");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    padRJ(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    exportHandler() {
      this.getData();
      let item = [];
      item.totalAmtEmployer = this.totalAmtEmployer;
      item.totalAmtMember = this.totalAmtMember;
      item.accounterr = this.accErr;
      item.successCount = this.successCount;
      item.processedCount = this.processedCount;
      item.errCount = this.errCount;

      if (!this.isErr) {
        this.$router.push({ name: "monthlyepfexportlog", params: { item } });
      }
    },

    backHandler() {
      this.$router.push({ name: "monthlyepfexport" });
    },

    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
  },

  mounted() {
  },
};
</script>

<style scoped>
</style>
